export const NOT_FOUND_ROUTE_NAMES = {
  NOT_FOUND: '404',
};
